export function logDebug(
  string: string | null = null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any = null,
  force = false,
) {
  if (process.env.NODE_ENV === "development" || force) {
    if (value !== null) {
      // eslint-disable-next-line no-console
      console.log(string, value);
    } else {
      // eslint-disable-next-line no-console
      console.log(string);
    }
  }
}

export function truncateString(str: string, num: number) {
  if (str.length > num) {
    return `${str.slice(0, num)}...`;
  }
  return str;
}

export const loadScript = (url: string, callback: () => void) => {
  const script: HTMLScriptElement = document.createElement("script"); // create script tag
  script.type = "text/javascript";
  script.defer = true;
  script.async = true;

  // when script state is ready and loaded or complete we will call callback
  if (script.readyState) {
    script.onreadystatechange = () => {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url; // load by url
  document.getElementsByTagName("head")[0].appendChild(script); // append to head
};
